import { useTransportQuery } from "@/transport"

import type { TagResource } from "@/types_api/backend/transport/list_organization_tags_response"

import { DeleteTagDialog } from "../components/DeleteTagDialog"

interface DeleteTagDialogRouteProps {
  tag: TagResource
  isPending: boolean
  isCatalogReady: boolean
  catalogError: string | null
  onRetryCatalog: () => void
  error: string | null
  onClose: () => void
  onConfirm: () => void
}

export function DeleteTagDialogRoute(props: DeleteTagDialogRouteProps) {
  const preview = useTransportQuery({
    operation: "listWorkspaceTags",
    request: { tag_id: props.tag.id, include_usage: true },
    options: {
      throwOnError: false,
      staleTime: 0,
      gcTime: 0,
      refetchOnMount: "always",
      abortOnUnmount: true,
    },
  })
  const count = preview.data?.tags.find(
    (tag) => tag.id === props.tag.id,
  )?.assignment_count
  const assignmentCount =
    typeof count === "number" && Number.isSafeInteger(count) && count >= 0
      ? count
      : null
  const isLoading = preview.isFetching || preview.isLoading
  const previewError = preview.isError
    ? "Tag usage could not be loaded. Try again before deleting."
    : !isLoading && assignmentCount === null
      ? "Current usage is unavailable. The tag may have changed or been deleted."
      : null

  return (
    <DeleteTagDialog
      {...props}
      assignmentCount={assignmentCount}
      isLoading={isLoading}
      previewError={previewError}
      onRetry={() => {
        void preview.refetch()
      }}
    />
  )
}
